import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { useAPIClient } from './useApi'
import { usePermissions } from './usePermissions'
import type { ActivityStatsDTO } from '@/api/generated/models'

export interface ActivityStats {
  totalUnacknowledged: number
  byType: { [key: string]: number }
}

// Transform API response to frontend format
const transformStats = (stats: ActivityStatsDTO): ActivityStats => ({
  totalUnacknowledged: stats.total_unacknowledged,
  byType: stats.by_type
})

export const useActivityStats = () => {
  const { activitiesApi } = useAPIClient()
  const { isAuthenticated } = useAuth0()
  const { hasPermission } = usePermissions()

  return useQuery({
    queryKey: ['activity-stats'],
    queryFn: async () => {
      const response = await activitiesApi.getActivityStatsApiV1ActivitiesStatsGet()
      return transformStats(response.data)
    },
    // Same permission that gates the Aktivität nav item
    enabled: isAuthenticated && hasPermission('event:view'),
    staleTime: 15 * 1000, // 15 seconds for near real-time updates
    gcTime: 1 * 60 * 1000, // 1 minute
  })
}
